import React from 'react';
import { Container, Header, Image } from 'semantic-ui-react';

import platformTeamImage from '../../../images/grafix-banner/platformTeamPage.svg';

const Account = () => (
  <Container className="demoImage">
    <Header as='h2' icon textAlign='center'>
      <Header.Content>
        Platform Account
        </Header.Content>
    </Header>
    <Image src={platformTeamImage} size='large' centered={true} />
  </Container>
);

export default Account;